/* eslint-disable react/prop-types */
import React from 'react';
import matchSorter from 'match-sorter';
import moment from 'moment';
import eol from 'eol';
import { Link } from 'react-router-dom';
import ReactSelect from 'react-select';
const { URL_PREFIX, SF_URL, SF_PAGE_URL} = window;

const FreezeProperty = {
  headerStyle: (left) => ({
    position: 'sticky',
    left: `${left}px`,
    backgroundColor: '#fff',
    zIndex: 2,
    boxShadow: '2px 0 5px -2px rgba(0, 0, 0, 0.1)',
  }),
  cellStyle: (left) => ({
    position: 'sticky',
    left: `${left}px`,
    backgroundColor: '#fff',
    zIndex: 1, // Lower z-index for cell
  }),
};

const flightConfig = {
    Header: 'Flight',
    accessor: 'flight',
    width: 150,
    Cell: cell => {
        const colorMap = {
            Out: '#ffcccc',  // Light red for 'Out'
            In: '#ccffcc',   // Light green for 'In'
            b2b: '#ccccff',  // Light blue for 'b2b'
        };
        const backgroundColor = colorMap[cell.value] || '#fff'; // Default to white if no match

        return (
            <div
                style={{
                    backgroundColor: backgroundColor,
                    boxShadow: '2px 0 5px -2px rgba(0, 0, 0, 0.1)',
                    padding: '8px', // Ensure there's padding for visibility
                }}
            >
                {cell.value}
            </div>
        );
    },
    filterable: true,
    filterMethod: (filter, row) => {
        if (filter.value && filter.value.length > 0) {
            if (filter.value.findIndex(o => o.value === row[filter.id]) > -1) return true;
            return false;
        }
        return true;
    },
    Filter: ({ onChange }) => (
        <ReactSelect
            options={[{
                value: 'Out', label: 'Out',
            }, {
                value: 'In', label: 'In',
            }, {
                value: 'b2b', label: 'b2b',
            }]}
            onChange={option => onChange(option)}
            isMulti
            styles={{
                menu: () => ({ zIndex: 999 }),
            }}
        />
    ), 
};

const getMaxWidth = (data) => {
    let maxWidth = 0;

    data.forEach(item => {
        const value = item.segment?.Room_Allocation__r?.Room_Assigned__r?.Name || ''; 
        const width = value.length * 10; 
        if (width > maxWidth) {
            maxWidth = width;
        }
    });

    return maxWidth + 30; // Adjust as needed
};

const roomAssigned = (fnTriggerEdit, data) => {
    const accessor = 'segment.Room_Allocation__r.Room_Assigned__r.Name';
    const maxWidth = getMaxWidth(data);

    return {
        Header: 'Room Assigned',
        accessor: accessor,
        minWidth: maxWidth, // Set a minimum width
        Cell: col => (
            <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                width: '100%', // Ensure full width for the cell
                padding: '8px', // Add padding for aesthetics
                boxSizing: 'border-box',
            }}>
                <p style={{ marginRight: 20 }}>{col.value}</p>
                <button className="btn btn-xs btn-primary" name={col.value} onClick={() => fnTriggerEdit(col.original.segment.Room_Allocation__c)}>
                    <i className="fa fa-edit" />
                </button>
            </div>
        ),
    };
};

// const roomAssigned = fnTriggerEdit => ({
//     Header: 'Room Assigned',
//     accessor: 'segment.Room_Allocation__r.Room_Assigned__r.Name',
//     Cell: col => (
//         <div className="flex" style={{justifyContent:'space-between'}}>
//             <p style={{ marginRight: 20 }}>{col.value}</p>
//             <button className="btn btn-xs btn-primary" name={col.value} onClick={() => fnTriggerEdit(col.original.segment.Room_Allocation__c)}>
//                 <i className="fa fa-edit" />
//             </button>
//         </div>
//     ),
// });

const defaultGuestList = guestList => [{
    Header: '#',
    // accessor: 'Id',
    width: 35,
    Cell: col => <p>{(col.viewIndex + 1).toString().padStart(2, '0')}</p>,
}, {
    Header: 'Salesperson',
    id: 'salesPerson',
    accessor: 'Sales_Order_No__r.Sales_Person__r.Name',
    filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['salesPerson'] }),
    filterAll: true,
    filterable: true,
}, {
    Header: 'So Number',
    accessor: 'Sales_Order_No__r.Name',
    Cell: col => (
        <a href={`${SF_PAGE_URL}${col.original.Sales_Order_No__c}`} target="_blank" rel="noopener noreferrer">
            {col.value}
        </a>
    ),
    filterable: true,
    // filterMethod: (filter, rows) => console.info(filter, rows),
}, flightConfig, {
    Header: 'Nationality',
    accessor: 'Nationality__c',
    Cell: col => <p>{col.value}</p>,
}, {
    Header: 'Guest Name',
    accessor: 'guestFullName',
    id: 'guestName',
    filterable: true,
    filterMethod: (filter, rows) => matchSorter(rows, filter.value, { keys: ['guestName'] }),
    filterAll: true,
    Cell: col => (
        <Link target="_blank" rel="noopener noreferrer" to={`${URL_PREFIX}/app/guest/${col.row._original.Id}`}>
            {col.value}
        </Link>
    ),
},
{
    Header: 'Type',
    accessor: 'segment.Segment_Type__c',
    Cell: col => <p>{col.value}</p>,
    filterable: true,
    Filter: ({ filter, onChange }) => (
        <select
            onChange={event => onChange(event.target.value)}
            value={filter ? filter.value : ''}
            className="form-control"
        >
            <option value="">All</option>
            <option value="Pelagian">Pelagian</option>
            <option value="Resort">Resort</option>
        </select>
    ),
}, {
    accessor: 'Total_Room_Nights__c',
    Header: () => <p>Total Room<br /> Nights</p>,
    Cell: col => <p style={{ textAlign: 'right' }}>{col.value}</p>,
}, {
    accessor: 'Visit_Status__c',
    Header: 'Visit Status',
    Cell: col => <p>{col.value}</p>,
    filterable: true,
    Filter: ({ filter, onChange }) => {
        const listOfVisitStatus = [];
        for (let i = 0; i < guestList.length; i++) {
            if (listOfVisitStatus.indexOf(guestList[i].Visit_Status__c) === -1) {
                listOfVisitStatus.push(guestList[i].Visit_Status__c);
            }
        }
        return (
            <select
                onChange={event => onChange(event.target.value)}
                value={filter ? filter.value : ''}
                className="form-control"
            >
                <option value="">All</option>
                {listOfVisitStatus.map(o => <option value={o} key={`${o}visitStatus`}>{o}</option>)}
            </select>
        );
    },
    getProps: (state, rowInfo) => {
        if (rowInfo && rowInfo.row && rowInfo.row.Visit_Status__c) {
            return {
                style: {
                    backgroundColor: rowInfo.row.Visit_Status__c.toLowerCase() === 'forecasted' ? '#ff5400' : null,
                    color: rowInfo.row.Visit_Status__c.toLowerCase() === 'forecasted' ? '#fff' : null,
                },
            };
        } return {};
    },
}, {
    accessor: 'segment.Start_Date__c',
    Header: 'Start Date',
    Cell: col => <p>{moment(col.value).format('DD-MMM-YYYY')}</p>,
}, {
    accessor: 'segment.End_Date__c',
    Header: 'End Date',
    Cell: col => <p>{moment(col.value).format('DD-MMM-YYYY')}</p>,
}, {
    accessor: 'segment.RoomType__c',
    Header: 'Room Type',
    Cell: col => (
        <p>
            {col.value}<br />
            ({col.row._original.segment ? col.row._original.segment.Sharing_Type__c : ''})
        </p>
    ),
    filterable: true,
    Filter: ({ filter, onChange }) => {
        const listOfRoomType = [];
        for (let i = 0; i < guestList.length; i++) {
            // eslint-disable-next-line no-continue
            if (guestList[i].segment === undefined) continue;
            if (listOfRoomType.indexOf(guestList[i].segment.RoomType__c) === -1) {
                listOfRoomType.push(guestList[i].segment.RoomType__c);
            }
        }
        return (
            <select
                onChange={event => onChange(event.target.value)}
                value={filter ? filter.value : ''}
                className="form-control"
            >
                <option value="">All</option>
                {listOfRoomType.map(o => <option value={o} key={`RoomType-${o}`}>{o}</option>)}
            </select>
        );
    },

}];

const getFieldInfo = (objDesc, objectName, fieldName) => {
    const objectDetail = objDesc.find(o => o.name === objectName);
    return objectDetail.fields.find(o => o.name === fieldName);
};

export const filterByView = (objDesc, selectedView = [], guestList = [], additionalFn = {
    changeRoomAssigned: () => null,
}, selectedDate = moment(), freezeColumn) => {
    if (selectedView.column === undefined) return defaultGuestList(guestList);
    const frozenColumns = freezeColumn.map((columnName, index) => ({
        columnName,
        left: index * 150,
    }));
    const columnConfig = selectedView.column.map((o) => {
        const frozenColumn = frozenColumns.find((f) => f.columnName === o.columnName);
        const left = frozenColumn ? frozenColumn.left : undefined;
        const fieldInfo = getFieldInfo(objDesc, o.objectName, o.columnName);
        const mapping = {
            Sales_Order__c: 'Sales_Order_No__r.',
            Guest__c: '',
            Opportunity: 'Sales_Order_No__r.Opportunity_Name__r.',
            Segment__c: 'segment.',
            Room_Allocation__c: 'segment.Room_Allocation__r.',
            FormulaField: '',
            Account: 'Sales_Order_No__r.Account_Name__r.',
            Contact: 'Guest_FullName__r.',
        };
        if (fieldInfo && fieldInfo.name === 'flight') 
            return freezeColumn.includes('flight') ? {...flightConfig, 
                headerStyle: FreezeProperty.headerStyle(left),
                style: FreezeProperty.cellStyle(left),
            } : flightConfig;
        if (o.objectName === 'Room_Allocation__c' && o.columnName === 'Room_Assigned__c') {
            return roomAssigned(additionalFn.changeRoomAssigned, guestList);
        }
        return {
            ...(freezeColumn.includes(o.columnName) ? {
                headerStyle: FreezeProperty.headerStyle(left),
                style: FreezeProperty.cellStyle(left),
            } : {}),
            width: 150,
            Header: fieldInfo.label,
            accessor: fieldInfo.type === 'reference' ? `${mapping[o.objectName]}${o.columnName.replace('__c', '__r.Name')}` : `${mapping[o.objectName]}${o.columnName}`,
            filterable: ['picklist', 'string', 'email', 'boolean', 'reference'].indexOf(fieldInfo.type) > -1,
            Filter: ({ filter, onChange }) => {
                if (fieldInfo.type === 'picklist') {
                    return (
                        <select
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            className="form-control"
                        >
                            <option value="">All</option>
                            {fieldInfo.picklistValues
                                .filter(picklistVal => picklistVal.active === true)
                                .map(picklistVal => (
                                    <option
                                        value={picklistVal.value}
                                        key={`${fieldInfo.name}-${picklistVal.value}`}
                                    >
                                        {picklistVal.label}
                                    </option>
                                ))
                            }
                        </select>
                    );
                }
                return (
                    <input
                        type="text"
                        className="form-control"
                        onChange={event => onChange(event.target.value)}
                        value={filter ? filter.value : ''}
                    />
                );
            },
            filterMethod: (filter, row) => {
                if (filter.value) {
                    if (filter.id.toLowerCase().includes('gender')) {
                        return row[filter.id] && row[filter.id].toLowerCase() === filter.value.toLowerCase();
                    }
                    return row[filter.id] && row[filter.id].toLowerCase().includes(filter.value.toLowerCase());
                }
                return true;
            },
            Cell: (col) => {
                const { value } = col;
                if (value === undefined) return '';
                if (o.objectName === 'Guest__c' && o.columnName === 'Guest_FullName__c') {
                    return (
                        <p>
                            <Link to={`${URL_PREFIX}/app/guest/${col.row._original.Id}?viewId=${selectedView._id}&date=${selectedDate.format('YYYY-MM-DD')}`}>
                                {value}
                            </Link>
                        </p>
                    );
                }
                if (fieldInfo.type === 'date') {
                    return <p>{value ? moment(value).format('DD-MMM-YYYY') : null}</p>;
                } else if (fieldInfo.type === 'datetime') {
                    return <p>{value ? moment(value).format('DD-MMM-YYYY hh:mm a') : null}</p>;
                } else if (fieldInfo.type === 'boolean') {
                    return <p>{value ? 'Yes' : 'No'}</p>;
                } else if (fieldInfo.type === 'currency') {
                    return <p className="text-right">${value != null ? value.toLocaleString() : ''}</p>;
                } else if (fieldInfo.type === 'textarea') {
                    return value ? <p className="text">{eol.auto(value)}</p> : null;
                }
                if (/^([\+-]?\d{4}(?!\d{2}\b))((-?)((0[1-9]|1[0-2])(\3([12]\d|0[1-9]|3[01]))?|W([0-4]\d|5[0-2])(-?[1-7])?|(00[1-9]|0[1-9]\d|[12]\d{2}|3([0-5]\d|6[1-6])))([T\s]((([01]\d|2[0-3])((:?)[0-5]\d)?|24\:?00)([\.,]\d+(?!:))?)?(\17[0-5]\d([\.,]\d+)?)?([zZ]|([\+-])([01]\d|2[0-3]):?([0-5]\d)?)?)?)?$/
                    .test(value)) {
                    return <p>{moment(value).format('DD-MMM-YYYY hh:mm')}</p>;
                }
                return <p>{value}</p>;
            },
        };
    });
    return [
        {
            Header: '#',
            width: 35,
            Cell: col => <p>{(col.viewIndex + 1).toString().padStart(2, '0')}</p>,
        },
    ].concat(columnConfig);
};

export default defaultGuestList;